// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"87096dd2","700":"d3423f98","845":"116b9008"}[chunkId] + ".chunk.js";
};